export const appVersion = String(import.meta.env.VITE_APP_VERSION);
export const googleReCaptchaSiteKey = '6LeE8r8qAAAAANx94TMbJRt61um9lGerbeU2rtF3';
